import { makeStyles } from "@material-ui/styles";

import { colors, fontFamilyHelvetica, fontFamilyIdealSans, greys } from "@styles/index";

export const pageMaxWidth = 1150;

export const useSetupLinkStyles = makeStyles({
  container: {
    margin: "5px 15px 20px",
    maxWidth: pageMaxWidth,
    minWidth: 360,
    color: greys.standard,
    fontFamily: fontFamilyHelvetica,

    "& .MuiCheckbox-colorPrimary": {
      color: colors.green.darker,
    },

    "& > h2": {
      fontFamily: fontFamilyIdealSans,
    },

    "& .MuiMenu-list": {
      maxHeight: 400,
    },
  },
  header: {
    fontFamily: fontFamilyIdealSans,
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: ".85rem",
    marginTop: 0,
    color: colors.blueDusk.standard,
  },
  top: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    borderBottom: "2px solid #EEF0F1",
    padding: "14px 10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  slug: {
    display: "flex",
    alignItems: "center",
    color: greys.slate,
    lineHeight: 1.1,
    flexShrink: 0,

    "& > span, & > svg": {
      backgroundColor: "rgba(0, 0, 0, 0.09)",
      boxSizing: "unset",
    },

    "& > svg": {
      padding: "6px 5px 6px 9px",
    },

    "& > span": {
      padding: "9px 0px 9px",
    },

    "& .MuiFilledInput-root": {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,

      "& .MuiFilledInput-input": {
        padding: "8px 10px 8px 4px",
      },
    },
  },
  bottom: {
    display: "flex",
    marginTop: 15,
    justifyContent: "center",
  },
  left: {
    display: "flex",
    flex: 0,
    flexGrow: 1,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 20,
    margin: "20px 50px",
    minWidth: 290,
    maxWidth: 400,
  },
  divider: {
    borderLeft: "2px solid #EEF0F1",
    margin: "-17px 45px 0px",
    flex: 0,
  },
  right: {
    display: "flex",
    flex: 0,
    flexDirection: "column",
    flexGrow: 1,
    alignItems: "flex-start",
    gap: 44,
    margin: "20px 50px",
    maxWidth: 470,
    minWidth: 330,
  },
  name: {
    "& .MuiFilledInput-multiline": {
      padding: "6px 6px 2px",
      lineHeight: 1.25,
      borderRadius: 2,
    },

    "& .MuiFilledInput-underline::before": {
      borderBottom: "none",
    },

    "& .MuiFilledInput-input": {
      fontFamily: fontFamilyIdealSans,
      fontSize: `${24 / 16}rem`,
      fontWeight: "bold",
      color: colors.blueDusk.darker,
      padding: "10px 12px 9px",
    },

    "& ::placeholder": {
      color: greys.medium,
    },
  },
  description: {
    fontFamily: fontFamilyHelvetica,
    lineHeight: 1.2,
    border: "none",
    backgroundColor: "rgba(0, 0, 0, 0.09)",
    minHeight: 58,
    maxHeight: 297, // Leaves a bit of the last row is visible
    maxWidth: 450,
    padding: 10,
    borderRadius: 6,
    color: greys.standard,
    fontSize: `${16 / 16}rem`,
    width: "100% !important",
    boxSizing: "border-box",

    "&::placeholder": {
      color: greys.lightishGrey,
    },
  },
  timing: {
    "& > div": {
      display: "flex",
      whiteSpace: "nowrap",
      gap: 13,
      alignItems: "center",
      justifyContent: "flex-start",
      marginBottom: 6,
    },

    "& > div > svg": {
      color: greys.slate,
      fontSize: 20,
      marginRight: 5,
    },
  },
  noMeetingDay: {
    marginBotton: 10,
  },
  time: { fontWeight: 600, fontSize: "1.0rem" },
  select: {
    margin: 6,
    borderRadius: 4,

    "& .MuiFilledInput-input": {
      padding: "11px 32px 9px 10px",
    },
  },
  datePicker: {
    margin: "6px",

    "& .MuiInputAdornment-root": {
      marginLeft: "0",
    },

    "& .MuiFilledInput-root": {
      borderRadius: "4px",
      paddingRight: "0px",
    },

    "& .MuiFilledInput-input": {
      padding: "12px 0px 11px 10px",
      fontSize: "14px",
      minWidth: "4.5rem",
    },

    "&:focus-within": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },
  datePickerInput: {
    "& .MuiTouchRipple-root": {
      display: "none",
    },

    "& .MuiIconButton-root": {
      paddingLeft: "0px",
      paddingRight: "4px",

      "&:focus": {
        color: colors.green.standard,
      },
    },
  },
  radios: {
    marginLeft: 9,
  },
  timeExamples: {
    backgroundColor: greys.paleGrey,
    padding: "18px 30px 30px",
    margin: 10,
    marginLeft: 0,
    minWidth: 206,
    maxHeight: 215,
    borderRadius: 6,
  },
  bestBadge: {
    background: colors.green.lightest,
    marginLeft: 8,
    color: colors.green.darkest,
    padding: "5px 10px 5px 10px",
    borderRadius: 4,
    fontSize: ".8125rem",
  },
  topBarRight: {
    display: "flex",
    columnGap: 15,
    alignItems: "center",
    justifyContent: "flex-end",
  },
  bestTimes: {
    lineHeight: 1.5,
    fontSize: `${14 / 16}rem`,
    margin: "0px 12px 10px 0px",
    minWidth: 205,
    fontFamily: fontFamilyHelvetica,
  },
});
